import { NavLink, Outlet } from "react-router-dom";
import { Package, LayoutDashboard, Truck, Warehouse, Boxes, FileText, ShoppingCart, ClipboardCheck, Layers, Settings } from "lucide-react";

const TABS = [
  { to: "/supply",           label: "Dashboard", icon: LayoutDashboard, end: true, testid: "sup-tab-dashboard" },
  { to: "/supply/items",     label: "Items",     icon: Boxes,                       testid: "sup-tab-items" },
  { to: "/supply/vendors",   label: "Vendors",   icon: Truck,                       testid: "sup-tab-vendors" },
  { to: "/supply/stores",    label: "Stores",    icon: Warehouse,                   testid: "sup-tab-stores" },
  { to: "/supply/stock",     label: "Stock",     icon: Layers,                      testid: "sup-tab-stock" },
  { to: "/supply/prs",       label: "Requests",  icon: FileText,                    testid: "sup-tab-prs" },
  { to: "/supply/pos",       label: "Orders",    icon: ShoppingCart,                testid: "sup-tab-pos" },
  { to: "/supply/grns",      label: "Receipts",  icon: ClipboardCheck,              testid: "sup-tab-grns" },
  { to: "/supply/settings",  label: "Settings",  icon: Settings,                    testid: "sup-tab-settings" },
];

export default function SupplyShell() {
  return (
    <div className="space-y-6" data-testid="supply-shell">
      <div className="flex items-baseline gap-3">
        <div className="w-11 h-11 rounded-xl bg-hocp-gold flex items-center justify-center shrink-0">
          <Package className="w-5 h-5 text-hocp-eerie" strokeWidth={2}/>
        </div>
        <div>
          <h1 className="font-display text-[26px] font-bold text-hocp-navy leading-none">Supply OS</h1>
          <p className="text-[13px] text-slate-500 mt-1.5">Inventory · Procurement · Stock ledger — modular per hotel.</p>
        </div>
      </div>

      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2.5 text-[13px] font-medium border-b-2 whitespace-nowrap transition-colors ${
                  isActive ? "border-hocp-navy text-hocp-navy" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
              <Icon className="w-4 h-4" strokeWidth={1.75}/>{t.label}
            </NavLink>
          );
        })}
      </div>

      <Outlet />
    </div>
  );
}
